// extracted by mini-css-extract-plugin
module.exports = {"duplicatedDocumentsWindow":"duplicatedDocumentsWindow__KuKH+","windowBody":"windowBody__c3c4U","tableColumn":"tableColumn__z1Jj2"};